import { boolean, object, string } from "zod/v4";

export const getWayfairIntegration = {
  name: "getWayfairIntegration" as const,
  input: object({}),
  output: object({
    wayfairIntegration: object({
      clientId: string(),
      isConnected: boolean(),
    }).optional(),
  }),
};
